import styled from 'styled-components'
import ClampBase from 'components/clamp'

export const Clamp = styled(ClampBase)`
    margin-bottom: 0;
`